import React from "react";
import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import GetAppIcon from "@mui/icons-material/GetApp";
import IosShareIcon from "@mui/icons-material/IosShare";
import useInstallPrompt from "../Helper/useInstallPrompt";
import { useTheme as useAppTheme } from "../context/ThemeContext";

// Dropped into the Owner/Tenant Profile screens so a mobile visitor can
// install OTS as an app instead of re-opening Chrome every time. Renders
// nothing once already installed, or on a desktop/browser that supports
// neither the native install prompt nor iOS's "Add to Home Screen".
const InstallAppCard = () => {
  const { canInstall, isIOS, isStandalone, promptInstall } = useInstallPrompt();
  const { theme: appTheme } = useAppTheme();
console.log(canInstall, 'canInstall');

  if (isStandalone || (!canInstall && !isIOS)) return null;

  return (
    <Card sx={{ borderRadius: 3, border: "1px solid", borderColor: "divider" }}>
      <CardContent sx={{ p: { xs: 2, md: 3 } }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1.5 }}>
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: `${appTheme.primary}1a`,
              color: appTheme.primary,
            }}
          >
            <GetAppIcon />
          </Box>
          <Box>
            <Typography variant="h6" fontWeight={600}>
              Get the OTS App
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Install OTS on this phone for quick, one-tap access.
            </Typography>
          </Box>
        </Box>

        {canInstall ? (
          <Button
            variant="contained"
            startIcon={<GetAppIcon />}
            onClick={promptInstall}
            sx={{
              bgcolor: appTheme.primary,
              "&:hover": { bgcolor: appTheme.primaryHover },
            }}
          >
            Download App
          </Button>
        ) : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              bgcolor: `${appTheme.primary}0d`,
              borderRadius: 2,
              p: 1.5,
            }}
          >
            <IosShareIcon sx={{ color: appTheme.primary, fontSize: 20 }} />
            <Typography variant="body2">
              Tap <strong>Share</strong>, then <strong>Add to Home Screen</strong>.
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default InstallAppCard;
